/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceStatus } from './BalanceStatus';
import {
    BalanceStatusFromJSON,
    BalanceStatusFromJSONTyped,
    BalanceStatusToJSON,
    BalanceStatusToJSONTyped,
} from './BalanceStatus';
import type { IdNameResultOflong } from './IdNameResultOflong';
import {
    IdNameResultOflongFromJSON,
    IdNameResultOflongFromJSONTyped,
    IdNameResultOflongToJSON,
    IdNameResultOflongToJSONTyped,
} from './IdNameResultOflong';
import type { IdNameResultOfint } from './IdNameResultOfint';
import {
    IdNameResultOfintFromJSON,
    IdNameResultOfintFromJSONTyped,
    IdNameResultOfintToJSON,
    IdNameResultOfintToJSONTyped,
} from './IdNameResultOfint';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { BalanceLineType } from './BalanceLineType';
import {
    BalanceLineTypeFromJSON,
    BalanceLineTypeFromJSONTyped,
    BalanceLineTypeToJSON,
    BalanceLineTypeToJSONTyped,
} from './BalanceLineType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetBalanceDetailResponse
 */
export interface GetBalanceDetailResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetBalanceDetailResponse
     */
    unitDetailId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceDetailResponse
     */
    referenceNo: string;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceDetailResponse
     */
    debit: number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceDetailResponse
     */
    credit: number;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceDetailResponse
     */
    currency: string;
    /**
     * 
     * @type {Date}
     * @memberof GetBalanceDetailResponse
     */
    transactionDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceDetailResponse
     */
    description: string | null;
    /**
     * 
     * @type {BalanceLineType}
     * @memberof GetBalanceDetailResponse
     */
    lineType: BalanceLineType;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceDetailResponse
     */
    idempotencyKey: string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceDetailResponse
     */
    paymentTransactionId: string | null;
    /**
     * 
     * @type {BalanceStatus}
     * @memberof GetBalanceDetailResponse
     */
    status: BalanceStatus;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetBalanceDetailResponse
     */
    month: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetBalanceDetailResponse
     */
    year: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceDetailResponse
     */
    transactionCode: string | null;
    /**
     * 
     * @type {IdNameResultOflong}
     * @memberof GetBalanceDetailResponse
     */
    appointmentBooking: IdNameResultOflong | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetBalanceDetailResponse
     */
    user: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetBalanceDetailResponse
     */
    student: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetBalanceDetailResponse
     */
    _class: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetBalanceDetailResponse
     */
    location: IdNameResultOfint | null;
}



/**
 * Check if a given object implements the GetBalanceDetailResponse interface.
 */
export function instanceOfGetBalanceDetailResponse(value: object): value is GetBalanceDetailResponse {
    if (!('unitDetailId' in value) || value['unitDetailId'] === undefined) return false;
    if (!('referenceNo' in value) || value['referenceNo'] === undefined) return false;
    if (!('debit' in value) || value['debit'] === undefined) return false;
    if (!('credit' in value) || value['credit'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('lineType' in value) || value['lineType'] === undefined) return false;
    if (!('idempotencyKey' in value) || value['idempotencyKey'] === undefined) return false;
    if (!('paymentTransactionId' in value) || value['paymentTransactionId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('transactionCode' in value) || value['transactionCode'] === undefined) return false;
    if (!('appointmentBooking' in value) || value['appointmentBooking'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('student' in value) || value['student'] === undefined) return false;
    if (!('_class' in value) || value['_class'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    return true;
}

export function GetBalanceDetailResponseFromJSON(json: any): GetBalanceDetailResponse {
    return GetBalanceDetailResponseFromJSONTyped(json, false);
}

export function GetBalanceDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBalanceDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'unitDetailId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['unitDetailId']),
        'referenceNo': json['referenceNo'],
        'debit': json['debit'],
        'credit': json['credit'],
        'currency': json['currency'],
        'transactionDate': (new Date(json['transactionDate'])),
        'description': json['description'],
        'lineType': BalanceLineTypeFromJSON(json['lineType']),
        'idempotencyKey': json['idempotencyKey'],
        'paymentTransactionId': json['paymentTransactionId'],
        'status': BalanceStatusFromJSON(json['status']),
        'month': ApiUserTasksGetPageParameterFromJSON(json['month']),
        'year': ApiUserTasksGetPageParameterFromJSON(json['year']),
        'transactionCode': json['transactionCode'],
        'appointmentBooking': IdNameResultOflongFromJSON(json['appointmentBooking']),
        'user': IdNameResultOfintFromJSON(json['user']),
        'student': IdNameResultOfintFromJSON(json['student']),
        '_class': IdNameResultOfintFromJSON(json['class']),
        'location': IdNameResultOfintFromJSON(json['location']),
    };
}

export function GetBalanceDetailResponseToJSON(json: any): GetBalanceDetailResponse {
    return GetBalanceDetailResponseToJSONTyped(json, false);
}

export function GetBalanceDetailResponseToJSONTyped(value?: GetBalanceDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'unitDetailId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['unitDetailId']),
        'referenceNo': value['referenceNo'],
        'debit': value['debit'],
        'credit': value['credit'],
        'currency': value['currency'],
        'transactionDate': value['transactionDate'].toISOString().substring(0,10),
        'description': value['description'],
        'lineType': BalanceLineTypeToJSON(value['lineType']),
        'idempotencyKey': value['idempotencyKey'],
        'paymentTransactionId': value['paymentTransactionId'],
        'status': BalanceStatusToJSON(value['status']),
        'month': ApiUserTasksGetPageParameterToJSON(value['month']),
        'year': ApiUserTasksGetPageParameterToJSON(value['year']),
        'transactionCode': value['transactionCode'],
        'appointmentBooking': IdNameResultOflongToJSON(value['appointmentBooking']),
        'user': IdNameResultOfintToJSON(value['user']),
        'student': IdNameResultOfintToJSON(value['student']),
        'class': IdNameResultOfintToJSON(value['_class']),
        'location': IdNameResultOfintToJSON(value['location']),
    };
}

